// React Imports
import React from "react";
import ReactDOM from "react-dom";

// Redux Imports
import { Provider } from "react-redux";
import { store, persistor } from "./redux/store";
import { PersistGate } from "redux-persist/integration/react";

// React Router Imports
import { Router, Route, Switch, Redirect } from "react-router-dom";
import { createBrowserHistory } from "history";

// addLocaleData([...locale_en, ...locale_de]);
import { I18nextProvider } from "react-i18next";
import i18n from "./i18next";

// File Imports
import Routes from "./routes/index.jsx";
import val from "./getThemeDetails.js";
import "./assets/scss/wallet-customer.scss";
import "./theme";
import "./assets/demo/demo.css";
import "react-table";
// import "react-table/react-table.css";
// import "sweetalert2/src/sweetalert2.scss";
import "sweetalert2/src/sweetalert2.js"
import "react-credit-cards/lib/styles.scss";
import "react-phone-input-2/lib/style.css";
import "@brainhubeu/react-carousel/lib/style.css";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import { Suspense } from "react";
import { Typography } from "@mui/material";
import Dashboard from "./layouts/Dashboard/Dashboard";


const NoMatch = React.lazy(() => import("./components/NoMatch.jsx"));

const ForgotPassword = React.lazy(() =>
  import("./components/ForgotPassword/ForgotPassword.jsx")
);

const SignUp = React.lazy(
  async () => (await import("./components/SignUp")).default
);
const Login = React.lazy(
  async () => (await import("./components/Login")).default
);


const hist = createBrowserHistory();

// window.addEventListener("load", (e) => {
//   e.preventDefault();
//   const favicon = document.getElementById("favicon");
//   if (favicon) {
//     favicon.href = `${process.env.PUBLIC_URL}/${val.theme}/${val.theme}_favicon.png`;
//   }
// });

window.addEventListener("load", (e) => {
  e.preventDefault();
  const favicon = document.getElementById("favicon");
  favicon.href = `${process.env.PUBLIC_URL}/${val.theme}/${val.theme}_favicon.png`;
  // return `${window.location.href}?walletOwnerId=${val.walletOwnerId}`;
});


window.addEventListener('unload', function () {
  localStorage.removeItem('authToken'); 
});

// console.log(sessionStorage.getItem("authToken"),"indauth")

const App = () => (
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <I18nextProvider i18n={i18n}>
        <TransitionGroup>
          <CSSTransition
            in={true}
            timeout={300}
            classNames="page"
            unmountOnExit
          >
            <Suspense fallback={<Typography>Loading...Please wait</Typography>}>
              <Router history={hist}>
                <Switch>
                  <Route
                    exact
                    path="/"
                    render={() =>
                      !store.getState().login.isAvailable || !sessionStorage.getItem("authToken") ? (
                        <Redirect
                          to={{
                            pathname: "/index/login",
                            // search: `?walletOwnerId=${val.walletOwnerId}`,
                          }}
                        />
                      ) : (
                        <Dashboard />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/index/login"
                    render={() =>
                      !store.getState().login.isAvailable || !sessionStorage.getItem("authToken") ? (
                        <Login />
                      ) : (
                        <Dashboard />
                      )
                    }
                  />

                  <Route
                    exact
                    path="/index/adminLogin"
                    render={() =>
                      !store.getState().login.isAvailable || !sessionStorage.getItem("authToken") ? (
                        <Login adminlogin="adminlogin" />
                      ) : (
                        <Dashboard />
                      )
                    }
                  />


                  <Route
                    exact
                    path="/index/forgot-password"
                    component={ForgotPassword}
                  />
                  <Route
                    exact
                    path="/index/signup"
                    render={() =>
                      !store.getState().login.isAvailable || !sessionStorage.getItem("authToken") ? (
                        <SignUp />
                      ) : (
                        <Dashboard />
                      )
                    }
                  />
                  {Routes.map((prop, key) => (
                    
                    <Route
                      path={prop.path}
                      key={key}
                      component={prop.component}
                    />
                  ))}

                  <Route exact component={NoMatch} />
                </Switch>
              </Router>
            </Suspense>
          </CSSTransition>
        </TransitionGroup>
      </I18nextProvider>
    </PersistGate>
  </Provider>
);

ReactDOM.render(<App />, document.getElementById("root"));


// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import './index.css';
// import App from './App';
// import reportWebVitals from './reportWebVitals';

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
